import { render, staticRenderFns } from "./CoinsCount.vue?vue&type=template&id=0a0291d2&scoped=true&"
import script from "./CoinsCount.vue?vue&type=script&lang=js&"
export * from "./CoinsCount.vue?vue&type=script&lang=js&"
import style0 from "./CoinsCount.vue?vue&type=style&index=0&id=0a0291d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0291d2",
  null
  
)

export default component.exports